/**
 * Casilla "Ver suspendidos" — componente compartido (Fase 4.5).
 *
 * Se usa en los listados operativos (Leads, Oportunidades, Propiedades...).
 * Existe como componente único y no copiado en cada pantalla por la razón que
 * ya documentó la auditoría de arquitectura: los catálogos y controles
 * duplicados divergen con el tiempo (pasó con el enum de status, que estaba
 * repetido en dos archivos).
 *
 * Contrato con el backend: los listados ocultan lo suspendido salvo que se
 * mande `?include_suspended=true`.
 *
 * Props:
 *   - checked / onChange : estado controlado por la pantalla
 *   - count?             : cuántos suspendidos hay (si la pantalla lo sabe)
 *   - testid?
 *   - label? / title?    : archivar-leads-de-prueba (2026-08-26) -- genericos
 *     para poder reusar el MISMO componente en "Ver archivados" (concepto
 *     distinto a "suspendido": archivado es ocultar leads de prueba a
 *     proposito, reversible por cualquier admin; suspendido es el soft-delete
 *     de destruction_policy.py, reversible solo por nivel Dios). Default
 *     preserva el texto/título de siempre para los callers existentes.
 */
import { Archive } from 'lucide-react';

export default function VerSuspendidos({
  checked, onChange, count, testid = 'ver-suspendidos',
  label = 'Ver suspendidos',
  title = 'Los elementos suspendidos siguen completos; solo se retiraron de la operación',
}) {
  return (
    <label
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border cursor-pointer select-none transition-colors ${
        checked
          ? 'border-amber-500/40 bg-amber-500/10 text-amber-300'
          : 'border-white/10 bg-black/20 text-muted-foreground hover:text-white/70'
      }`}
      title={title}
      data-testid={testid}
    >
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        className="w-3 h-3 accent-amber-400 cursor-pointer"
        data-testid={`${testid}-input`}
      />
      <Archive className="w-3 h-3" />
      <span className="text-[11px] whitespace-nowrap">
        {label}{typeof count === 'number' && count > 0 ? ` (${count})` : ''}
      </span>
    </label>
  );
}
